jQuery(document).ready(function($){
    
/*var slider = new Swiper ('.gallery-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        loopedSlides: 6,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            thumbs
        }
    });
    
    var thumbs = new Swiper ('.gallery-thumbs', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: false,
        loop: true,
        slideToClickedSlide: true,
    });
    
    slider.controller.control = thumbs;*/
    //thumbs.controller.control = slider;

  /**********/

      var swiper = new Swiper(".gallery-thumbs1", {
			loop: !0,
			spaceBetween: 10,
			slidesPerView: 4,
			freeMode: !0,
			watchSlidesProgress: !0
		}),
		swiper2 = new Swiper(".gallery-slider1", {
			loop: !0,
			spaceBetween: 10,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			},
			thumbs: {
				swiper
			}
		});

  

  /**********/
  /*
    new Swiper('.ltswipecont', {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 1500,
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper('.testiswipecont', {
        spaceBetween: 25,
        centeredSlides: false,
        speed: 25000,
         autoplay: {
          delay: 1,
        },
        loop: true,
        loopedSlides: 4,
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper('.sponswipecont', {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 25000,
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: '1',
        allowTouchMove: false,
        disableOnInteraction: true,
        navigation: {
            nextEl: '.swiper-button-next.swtesti',
            prevEl: '.swiper-button-prev.swtesti',
        }
    });*/

    
  
    $('body').on('click', '.pro_vid a', function(e) {
      e.preventDefault();
      Fancybox.show([{ src: "#product-video", type: "inline" }]);
    });



});
